import classNames from 'classnames';
import React from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { localeStore } from 'src/mobx/localesStore';
import { formatImagePath } from 'src/utils/formatter';
import './style.scss';

interface IProps {
  text: string;
  textClassName?: string;
  showEmptyListImage?: boolean;
}

export const EmptyList: React.FC<IProps> = ({ text = 'item_not_found', textClassName, showEmptyListImage = false }: IProps) => {
  return (
    <div className="empty-list py-5">
      {showEmptyListImage ? <img src={formatImagePath(`${Icons.NoResults}.svg`)} alt={text} className="image__no-found mb-6" /> : null}
      <p className={classNames('color-gray2 text-center', textClassName)}>{localeStore.t(text)}</p>
    </div>
  );
};
